export const UI = {
  fr: {
    nav: {
      works: "Type de travaux",
      partner: "Devenir partenaire",
      myspace: "Mon espace",
      blog: "Conseils",
      cta: "Demander un devis",
    },
    blog: {
      metaTitle: "Blog & Conseils Travaux | DevisMaison.be",
      metaDesc: "Prix des travaux, primes régionales, conseils rénovation : nos guides pour réussir vos projets en Belgique et au Luxembourg.",
      title: "Conseils & Guides Travaux",
      subtitle: "Prix, primes et conseils d'experts pour réussir vos projets de construction et rénovation.",
      readMore: "Lire l'article",
      back: "Tous les articles",
      empty: "Aucun article pour le moment.",
      published: "Publié le",
      categories: { prix: "Prix", primes: "Primes", conseils: "Conseils" },
      ctaTitle: "Un projet de travaux ?",
      ctaText: "Recevez gratuitement jusqu'à 5 devis d'entrepreneurs qualifiés de votre région.",
      ctaBtn: "Demander mes devis gratuits",
      share: "Partager cet article :",
      nlTitle: "Restez informé",
      nlText: "Recevez nos nouveaux guides : prix des travaux, primes et conseils rénovation. Pas de spam.",
      nlPlaceholder: "Votre adresse email",
      nlBtn: "S'inscrire",
      nlSuccess: "Merci ! Vous êtes bien inscrit à la newsletter.",
      nlAlready: "Vous êtes déjà inscrit à la newsletter.",
      nlError: "Adresse email invalide ou erreur. Réessayez.",
    },
    footer: {
      tagline: "La plateforme de référence pour vos projets de construction et rénovation en Belgique et au Luxembourg.",
      location: "Bertrix, Belgique",
      services: "Nos services",
      cities: "Nos villes",
      info: "Informations",
      contractorSpace: "Espace entrepreneur",
      adminSpace: "Espace admin",
      terms: "Conditions générales",
      privacy: "Politique de confidentialité",
      rights: "Tous droits réservés.",
      devisPrefix: "Devis",
      worksAt: "Travaux à",
      region: "Belgique & Luxembourg",
    },
    home: {
      metaTitle: "DevisMaison.be - Devis gratuits pour vos travaux en Belgique & Luxembourg",
      metaDesc: "Comparez jusqu'à 5 devis gratuits d'entrepreneurs qualifiés. Toiture, rénovation, cuisine, plomberie, isolation et 22 types de travaux en Belgique et Luxembourg.",
      ogTitle: "DevisMaison.be - Devis gratuits pour vos travaux",
      ogDesc: "Comparez jusqu'à 5 devis gratuits d'entrepreneurs qualifiés en Belgique et Luxembourg.",
      kicker: "Belgique & Luxembourg",
      h1a: "Recevez jusqu'à",
      h1b: "5 devis gratuits",
      h1c: "pour vos travaux",
      sub: "Comparez les meilleurs artisans de votre région pour vos projets de construction et rénovation. Simple, rapide et sans engagement.",
      cta: "Demander un devis gratuit",
      free: "100% Gratuit",
      noCommit: "Sans engagement",
      howTitle: "Comment ça marche ?",
      howSub: "Obtenez des devis pour vos travaux en 3 étapes simples",
      steps: [
        { number: "1", title: "Décrivez votre projet", description: "Remplissez notre formulaire en 2 minutes" },
        { number: "2", title: "Recevez des devis", description: "Jusqu'à 5 devis gratuits sous 48h" },
        { number: "3", title: "Comparez et choisissez", description: "Sélectionnez l'offre qui vous convient" },
      ],
      catsTitle: "Tous types de travaux",
      catsSub: "Des artisans qualifiés pour chaque projet de construction et rénovation",
      askQuote: "Demander un devis",
      seeAll: "Voir tous les services",
      whyTitle: "Pourquoi choisir DevisMaison.be ?",
      whySub: "La plateforme de confiance pour vos projets en Belgique et au Luxembourg",
      advantages: [
        { title: "100% Gratuit", description: "Aucun frais pour les propriétaires" },
        { title: "Jusqu'à 5 devis", description: "Comparez et choisissez le meilleur" },
        { title: "Artisans vérifiés", description: "Professionnels qualifiés uniquement" },
        { title: "Réponse rapide", description: "Devis sous 48h garantis" },
      ],
      reviewsTitle: "Avis de nos clients",
      reviewsSub: "Des avis vérifiés de propriétaires ayant utilisé notre plateforme",
      ctaTitle: "Prêt à démarrer votre projet ?",
      ctaSub: "Recevez gratuitement jusqu'à 5 devis de professionnels qualifiés près de chez vous.",
      ctaBtn: "Demander mes devis gratuits",
    },
    form: {
      stepOf: (c, t) => `Étape ${c} sur ${t}`,
      s1Title: "Quel type de travaux souhaitez-vous réaliser ?",
      s2Title: "Décrivez votre projet",
      s2Placeholder: "Décrivez les travaux que vous souhaitez réaliser, l'état actuel, les matériaux souhaités...",
      s2Min: (n) => `Minimum 10 caractères (${n}/10)`,
      s3Budget: "Quel est votre budget estimé ?",
      s3When: "Quand souhaitez-vous commencer ?",
      s3Date: "Date de commencement souhaitée",
      s3DateHint: "Optionnel — date approximative de début des travaux",
      s4Title: "Où se situe votre projet ?",
      postal: "Code postal",
      city: "Ville",
      cityPlaceholder: "Bruxelles",
      s5Title: "Vos coordonnées",
      firstName: "Prénom",
      lastName: "Nom",
      email: "Email",
      phone: "Téléphone",
      contactMethod: "Comment préférez-vous être contacté ?",
      byPhone: "Par téléphone",
      byEmail: "Par email",
      both: "Les deux",
      contactHours: "Heures de contact préférées",
      morning: "Matin (8h-12h)",
      afternoon: "Après-midi (12h-17h)",
      evening: "Soirée (17h-20h)",
      flexible: "Flexible",
      docs: "Documents joints (optionnel)",
      docsHint: "Ajoutez des plans, devis ou tout document utile (PDF, XLSX — max 10 MB par fichier)",
      clickAdd: "Cliquez pour ajouter",
      files: "des fichiers",
      s6Title: "Vérifiez votre email",
      s6Text1: "Un code à 6 chiffres a été envoyé à",
      s6Text2: "Entrez-le ci-dessous pour confirmer votre demande.",
      resend: "Renvoyer le code",
      back: "Retour",
      next: "Continuer",
      verifyEmail: "Vérifier mon email",
      confirm: "Confirmer et envoyer",
      sending: "Envoi...",
      successTitle: "Demande envoyée !",
      successText: "Vous recevrez jusqu'à 5 devis gratuits de professionnels qualifiés dans les prochaines 48 heures.",
      newRequest: "Nouvelle demande",
      toastCodeSent: (email) => `Un code de vérification a été envoyé à ${email}`,
      toastCodeAlready: "Un code vous a déjà été envoyé récemment. Vérifiez votre boîte mail.",
      toastCodeFail: "Impossible d'envoyer le code. Vérifiez votre adresse email.",
      toastNewCode: "Nouveau code envoyé",
      toastResendFail: "Impossible de renvoyer le code",
      toastWrongCode: "Code incorrect",
      toastSuccess: "Votre demande a été envoyée avec succès !",
      toastError: "Une erreur est survenue. Veuillez réessayer.",
      budgets: [
        { value: "moins-5000", label: "Moins de 5 000 €" },
        { value: "5000-10000", label: "5 000 € - 10 000 €" },
        { value: "10000-20000", label: "10 000 € - 20 000 €" },
        { value: "20000-50000", label: "20 000 € - 50 000 €" },
        { value: "50000+", label: "Plus de 50 000 €" },
      ],
      timelines: [
        { value: "urgent", label: "Urgent (< 1 mois)" },
        { value: "1-3-mois", label: "1 à 3 mois" },
        { value: "3-6-mois", label: "3 à 6 mois" },
        { value: "6-12-mois", label: "6 à 12 mois" },
        { value: "flexible", label: "Je suis flexible" },
      ],
    },
    cat: {
      kicker: "Belgique & Luxembourg",
      descSuffix: "Comparez les offres de professionnels qualifiés de votre région.",
      cta: "Demander un devis gratuit",
      free: "100% Gratuit",
      noCommit: "Sans engagement",
      inBelgium: "en Belgique",
      typesTitle: "Types de travaux",
      pricesTitle: "Prix indicatifs",
      pricesNote: "* Prix indicatifs, TVA incluse. Demandez un devis pour un prix précis.",
      primesTitle: "Primes et aides disponibles",
      primesText: "Profitez des primes régionales pour vos travaux de rénovation énergétique en Belgique.",
      primesLink: "Découvrir les primes",
      bannerTitle: "Des artisans qualifiés près de chez vous",
      bannerText: "Tous nos partenaires sont des professionnels vérifiés, avec des références et une assurance décennale.",
      bannerBtn: "Obtenir mes devis gratuits",
    },
    city: {
      titlePrefix: "Devis",
      at: "à",
      heroSub: (cat, city) => `Recevez jusqu'à 5 devis gratuits de professionnels qualifiés pour vos travaux de ${cat} à ${city} et ses environs.`,
      metaDesc: (cat, city, region) => `Recevez jusqu'à 5 devis gratuits pour vos travaux de ${cat} à ${city}. Comparez les entrepreneurs qualifiés de la région ${region}.`,
      cta: "Demander un devis gratuit",
      localArtisans: "Artisans locaux",
      noCommit: "Sans engagement",
      networkText: (cat) => ` Notre réseau de professionnels qualifiés couvre toute la région et peut intervenir rapidement pour vos projets de ${cat}.`,
      whyTitle: (city) => `Pourquoi choisir nos artisans à ${city} ?`,
      whyItems: [
        "Artisans locaux avec connaissance du terrain",
        "Intervention rapide dans toute la région",
        "Devis détaillés et sans engagement",
        "Professionnels assurés et certifiés",
        "Accompagnement pour les primes régionales",
      ],
      statsTitle: (city) => `${city} en chiffres`,
      statPartners: "Artisans partenaires",
      statProjects: "Projets réalisés",
      statSatisfaction: "Satisfaction client",
      statDelay: "Délai moyen devis",
      zoneTitle: "Zone d'intervention",
      zoneText: (city) => `Nos artisans interviennent à ${city} et dans un rayon de 30 km, couvrant toutes les communes environnantes.`,
      zoneLink: "Demander un devis",
      ctaTitle: (city) => `Prêt à démarrer vos travaux à ${city} ?`,
      ctaSub: "Recevez gratuitement jusqu'à 5 devis de professionnels qualifiés de votre région.",
      ctaBtn: "Demander mes devis gratuits",
    },
    contractor: {
      metaTitle: "Devenir partenaire | DevisMaison.be",
      badge: "Espace Entrepreneur",
      h1a: "Développez votre",
      h1b: "activité",
      sub: "Rejoignez notre réseau de professionnels et recevez des demandes de devis de propriétaires à la recherche de vos services.",
      advantages: [
        "Inscription 100% gratuite",
        "Recevez des demandes de devis qualifiées",
        "Développez votre clientèle",
        "Aucun engagement",
        "Support dédié",
      ],
      formTitle: "Inscription gratuite",
      formSub: "Créez votre compte en quelques minutes",
      companyName: "Nom de l'entreprise *",
      companyPlaceholder: "Votre entreprise SPRL",
      vat: "Numéro de TVA *",
      email: "Email *",
      phone: "Téléphone *",
      password: "Mot de passe *",
      pwLength: "Au moins 8 caractères",
      pwUpper: "Une lettre majuscule",
      pwDigit: "Un chiffre",
      areas: "Zone d'intervention *",
      types: "Types de travaux *",
      submit: "S'inscrire gratuitement",
      submitting: "Inscription...",
      legal: "En créant votre compte, vous acceptez nos conditions générales et notre politique de confidentialité.",
      verifyTitle: "Vérifiez votre email",
      verifyText1: "Un code à 6 chiffres a été envoyé à",
      verifyText2: "Entrez-le ci-dessous pour activer votre compte.",
      verifying: "Vérification...",
      activate: "Activer mon compte",
      resend: "Renvoyer le code",
      successTitle: "Bienvenue dans notre réseau !",
      successText: "Votre compte entrepreneur a été créé avec succès. Vous recevrez les leads correspondant à vos critères par email.",
      howTitle: "Comment ça marche ?",
      howSteps: [
        "Vous recevez les leads par email selon vos critères",
        "Consultez les détails du projet et du client",
        "Achetez uniquement les leads qui vous intéressent",
        "Contactez directement le client pour proposer votre devis",
      ],
      backHome: "Retour à l'accueil",
      serviceAreas: [
        { value: "bruxelles", label: "Bruxelles-Capitale" },
        { value: "wallonie", label: "Wallonie" },
        { value: "flandre", label: "Flandre" },
        { value: "luxembourg", label: "Luxembourg" },
      ],
      toastCodeSent: "Un code de vérification a été envoyé à votre adresse email",
      toastVerified: "Compte vérifié avec succès !",
      toastWrongCode: "Code incorrect",
      toastNewCode: "Nouveau code envoyé",
      toastResendFail: "Impossible de renvoyer le code",
      toastError: "Une erreur est survenue. Veuillez réessayer.",
    },
  },
  nl: {
    nav: {
      works: "Soort werken",
      partner: "Partner worden",
      myspace: "Mijn account",
      blog: "Tips",
      cta: "Offerte aanvragen",
    },
    blog: {
      metaTitle: "Blog & Tips voor uw Werken | DevisMaison.be",
      metaDesc: "Prijzen van werken, regionale premies, renovatietips: onze gidsen voor geslaagde projecten in België en Luxemburg.",
      title: "Tips & Gidsen voor uw Werken",
      subtitle: "Prijzen, premies en expertadvies voor geslaagde bouw- en renovatieprojecten.",
      readMore: "Lees het artikel",
      back: "Alle artikels",
      empty: "Nog geen artikels.",
      published: "Gepubliceerd op",
      categories: { prix: "Prijzen", primes: "Premies", conseils: "Tips" },
      ctaTitle: "Een bouwproject?",
      ctaText: "Ontvang gratis tot 5 offertes van gekwalificeerde aannemers uit uw regio.",
      ctaBtn: "Mijn gratis offertes aanvragen",
      share: "Deel dit artikel:",
      nlTitle: "Blijf op de hoogte",
      nlText: "Ontvang onze nieuwe gidsen: prijzen, premies en renovatietips. Geen spam.",
      nlPlaceholder: "Uw e-mailadres",
      nlBtn: "Inschrijven",
      nlSuccess: "Bedankt! U bent ingeschreven op de nieuwsbrief.",
      nlAlready: "U bent al ingeschreven op de nieuwsbrief.",
      nlError: "Ongeldig e-mailadres of fout. Probeer opnieuw.",
    },
    footer: {
      tagline: "Hét referentieplatform voor uw bouw- en renovatieprojecten in België en Luxemburg.",
      location: "Bertrix, België",
      services: "Onze diensten",
      cities: "Onze steden",
      info: "Informatie",
      contractorSpace: "Aannemersruimte",
      adminSpace: "Admin",
      terms: "Algemene voorwaarden",
      privacy: "Privacybeleid",
      rights: "Alle rechten voorbehouden.",
      devisPrefix: "Offerte",
      worksAt: "Werken in",
      region: "België & Luxemburg",
    },
    home: {
      metaTitle: "DevisMaison.be - Gratis offertes voor uw werken in België & Luxemburg",
      metaDesc: "Vergelijk tot 5 gratis offertes van gekwalificeerde aannemers. Dakwerken, renovatie, keuken, loodgieterij, isolatie en 22 soorten werken in België en Luxemburg.",
      ogTitle: "DevisMaison.be - Gratis offertes voor uw werken",
      ogDesc: "Vergelijk tot 5 gratis offertes van gekwalificeerde aannemers in België en Luxemburg.",
      kicker: "België & Luxemburg",
      h1a: "Ontvang tot",
      h1b: "5 gratis offertes",
      h1c: "voor uw werken",
      sub: "Vergelijk de beste vakmensen uit uw regio voor uw bouw- en renovatieprojecten. Eenvoudig, snel en vrijblijvend.",
      cta: "Gratis offerte aanvragen",
      free: "100% Gratis",
      noCommit: "Vrijblijvend",
      howTitle: "Hoe werkt het?",
      howSub: "Ontvang offertes voor uw werken in 3 eenvoudige stappen",
      steps: [
        { number: "1", title: "Beschrijf uw project", description: "Vul ons formulier in 2 minuten in" },
        { number: "2", title: "Ontvang offertes", description: "Tot 5 gratis offertes binnen 48u" },
        { number: "3", title: "Vergelijk en kies", description: "Selecteer het aanbod dat u past" },
      ],
      catsTitle: "Alle soorten werken",
      catsSub: "Gekwalificeerde vakmensen voor elk bouw- en renovatieproject",
      askQuote: "Offerte aanvragen",
      seeAll: "Bekijk alle diensten",
      whyTitle: "Waarom kiezen voor DevisMaison.be?",
      whySub: "Het vertrouwde platform voor uw projecten in België en Luxemburg",
      advantages: [
        { title: "100% Gratis", description: "Geen kosten voor eigenaars" },
        { title: "Tot 5 offertes", description: "Vergelijk en kies de beste" },
        { title: "Geverifieerde vakmensen", description: "Enkel gekwalificeerde professionals" },
        { title: "Snel antwoord", description: "Offertes binnen 48u gegarandeerd" },
      ],
      reviewsTitle: "Klantenbeoordelingen",
      reviewsSub: "Geverifieerde beoordelingen van eigenaars die ons platform gebruikten",
      ctaTitle: "Klaar om uw project te starten?",
      ctaSub: "Ontvang gratis tot 5 offertes van gekwalificeerde professionals bij u in de buurt.",
      ctaBtn: "Mijn gratis offertes aanvragen",
    },
    form: {
      stepOf: (c, t) => `Stap ${c} van ${t}`,
      s1Title: "Welk soort werken wilt u laten uitvoeren?",
      s2Title: "Beschrijf uw project",
      s2Placeholder: "Beschrijf de werken die u wilt laten uitvoeren, de huidige staat, de gewenste materialen...",
      s2Min: (n) => `Minimum 10 tekens (${n}/10)`,
      s3Budget: "Wat is uw geschat budget?",
      s3When: "Wanneer wilt u starten?",
      s3Date: "Gewenste startdatum",
      s3DateHint: "Optioneel — geschatte startdatum van de werken",
      s4Title: "Waar bevindt uw project zich?",
      postal: "Postcode",
      city: "Gemeente",
      cityPlaceholder: "Brussel",
      s5Title: "Uw contactgegevens",
      firstName: "Voornaam",
      lastName: "Naam",
      email: "E-mail",
      phone: "Telefoon",
      contactMethod: "Hoe wordt u het liefst gecontacteerd?",
      byPhone: "Telefonisch",
      byEmail: "Per e-mail",
      both: "Beide",
      contactHours: "Voorkeursuren voor contact",
      morning: "Voormiddag (8u-12u)",
      afternoon: "Namiddag (12u-17u)",
      evening: "Avond (17u-20u)",
      flexible: "Flexibel",
      docs: "Bijlagen (optioneel)",
      docsHint: "Voeg plannen, offertes of nuttige documenten toe (PDF, XLSX — max 10 MB per bestand)",
      clickAdd: "Klik om bestanden",
      files: "toe te voegen",
      s6Title: "Controleer uw e-mail",
      s6Text1: "Een 6-cijferige code werd verzonden naar",
      s6Text2: "Voer deze hieronder in om uw aanvraag te bevestigen.",
      resend: "Code opnieuw verzenden",
      back: "Terug",
      next: "Verder",
      verifyEmail: "Mijn e-mail verifiëren",
      confirm: "Bevestigen en verzenden",
      sending: "Verzenden...",
      successTitle: "Aanvraag verzonden!",
      successText: "U ontvangt tot 5 gratis offertes van gekwalificeerde professionals binnen de komende 48 uur.",
      newRequest: "Nieuwe aanvraag",
      toastCodeSent: (email) => `Een verificatiecode werd verzonden naar ${email}`,
      toastCodeAlready: "Er werd u recent al een code verzonden. Controleer uw mailbox.",
      toastCodeFail: "Kan de code niet verzenden. Controleer uw e-mailadres.",
      toastNewCode: "Nieuwe code verzonden",
      toastResendFail: "Kan de code niet opnieuw verzenden",
      toastWrongCode: "Foute code",
      toastSuccess: "Uw aanvraag werd succesvol verzonden!",
      toastError: "Er is een fout opgetreden. Probeer opnieuw.",
      budgets: [
        { value: "moins-5000", label: "Minder dan 5 000 €" },
        { value: "5000-10000", label: "5 000 € - 10 000 €" },
        { value: "10000-20000", label: "10 000 € - 20 000 €" },
        { value: "20000-50000", label: "20 000 € - 50 000 €" },
        { value: "50000+", label: "Meer dan 50 000 €" },
      ],
      timelines: [
        { value: "urgent", label: "Dringend (< 1 maand)" },
        { value: "1-3-mois", label: "1 tot 3 maanden" },
        { value: "3-6-mois", label: "3 tot 6 maanden" },
        { value: "6-12-mois", label: "6 tot 12 maanden" },
        { value: "flexible", label: "Ik ben flexibel" },
      ],
    },
    cat: {
      kicker: "België & Luxemburg",
      descSuffix: "Vergelijk de offertes van gekwalificeerde professionals uit uw regio.",
      cta: "Gratis offerte aanvragen",
      free: "100% Gratis",
      noCommit: "Vrijblijvend",
      inBelgium: "in België",
      typesTitle: "Soorten werken",
      pricesTitle: "Richtprijzen",
      pricesNote: "* Richtprijzen, incl. btw. Vraag een offerte aan voor een exacte prijs.",
      primesTitle: "Beschikbare premies en steun",
      primesText: "Profiteer van de regionale premies voor uw energetische renovatiewerken in België.",
      primesLink: "Ontdek de premies",
      bannerTitle: "Gekwalificeerde vakmensen bij u in de buurt",
      bannerText: "Al onze partners zijn geverifieerde professionals, met referenties en een tienjarige aansprakelijkheidsverzekering.",
      bannerBtn: "Mijn gratis offertes ontvangen",
    },
    city: {
      titlePrefix: "Offerte",
      at: "in",
      heroSub: (cat, city) => `Ontvang tot 5 gratis offertes van gekwalificeerde professionals voor uw ${cat} in ${city} en omgeving.`,
      metaDesc: (cat, city, region) => `Ontvang tot 5 gratis offertes voor uw ${cat} in ${city}. Vergelijk gekwalificeerde aannemers uit de regio ${region}.`,
      cta: "Gratis offerte aanvragen",
      localArtisans: "Lokale vakmensen",
      noCommit: "Vrijblijvend",
      networkText: (cat) => ` Ons netwerk van gekwalificeerde professionals dekt de hele regio en kan snel ingrijpen voor uw ${cat}-projecten.`,
      whyTitle: (city) => `Waarom kiezen voor onze vakmensen in ${city}?`,
      whyItems: [
        "Lokale vakmensen met terreinkennis",
        "Snelle interventie in de hele regio",
        "Gedetailleerde en vrijblijvende offertes",
        "Verzekerde en gecertificeerde professionals",
        "Begeleiding bij regionale premies",
      ],
      statsTitle: (city) => `${city} in cijfers`,
      statPartners: "Partnervakmensen",
      statProjects: "Uitgevoerde projecten",
      statSatisfaction: "Klanttevredenheid",
      statDelay: "Gem. offertetermijn",
      zoneTitle: "Werkgebied",
      zoneText: (city) => `Onze vakmensen werken in ${city} en binnen een straal van 30 km, in alle omliggende gemeenten.`,
      zoneLink: "Offerte aanvragen",
      ctaTitle: (city) => `Klaar om uw werken in ${city} te starten?`,
      ctaSub: "Ontvang gratis tot 5 offertes van gekwalificeerde professionals uit uw regio.",
      ctaBtn: "Mijn gratis offertes aanvragen",
    },
    contractor: {
      metaTitle: "Partner worden | DevisMaison.be",
      badge: "Aannemersruimte",
      h1a: "Laat uw",
      h1b: "activiteit groeien",
      sub: "Sluit u aan bij ons netwerk van professionals en ontvang offerteaanvragen van eigenaars die op zoek zijn naar uw diensten.",
      advantages: [
        "100% gratis registratie",
        "Ontvang gekwalificeerde offerteaanvragen",
        "Breid uw klantenbestand uit",
        "Geen verplichtingen",
        "Toegewijde ondersteuning",
      ],
      formTitle: "Gratis registratie",
      formSub: "Maak uw account aan in enkele minuten",
      companyName: "Bedrijfsnaam *",
      companyPlaceholder: "Uw bedrijf BV",
      vat: "Btw-nummer *",
      email: "E-mail *",
      phone: "Telefoon *",
      password: "Wachtwoord *",
      pwLength: "Minstens 8 tekens",
      pwUpper: "Een hoofdletter",
      pwDigit: "Een cijfer",
      areas: "Werkgebied *",
      types: "Soorten werken *",
      submit: "Gratis registreren",
      submitting: "Registreren...",
      legal: "Door uw account aan te maken, aanvaardt u onze algemene voorwaarden en ons privacybeleid.",
      verifyTitle: "Controleer uw e-mail",
      verifyText1: "Een 6-cijferige code werd verzonden naar",
      verifyText2: "Voer deze hieronder in om uw account te activeren.",
      verifying: "Verifiëren...",
      activate: "Mijn account activeren",
      resend: "Code opnieuw verzenden",
      successTitle: "Welkom in ons netwerk!",
      successText: "Uw aannemersaccount werd succesvol aangemaakt. U ontvangt de leads die aan uw criteria voldoen per e-mail.",
      howTitle: "Hoe werkt het?",
      howSteps: [
        "U ontvangt leads per e-mail volgens uw criteria",
        "Bekijk de details van het project en de klant",
        "Koop enkel de leads die u interesseren",
        "Contacteer de klant rechtstreeks om uw offerte voor te stellen",
      ],
      backHome: "Terug naar de startpagina",
      serviceAreas: [
        { value: "bruxelles", label: "Brussels Gewest" },
        { value: "wallonie", label: "Wallonië" },
        { value: "flandre", label: "Vlaanderen" },
        { value: "luxembourg", label: "Luxemburg" },
      ],
      toastCodeSent: "Een verificatiecode werd naar uw e-mailadres verzonden",
      toastVerified: "Account succesvol geverifieerd!",
      toastWrongCode: "Foute code",
      toastNewCode: "Nieuwe code verzonden",
      toastResendFail: "Kan de code niet opnieuw verzenden",
      toastError: "Er is een fout opgetreden. Probeer opnieuw.",
    },
  },
};
